import { EntitySchema } from "mock/schemas"

const entitiesArray = [
    [
        "1",
        "Ortec Environment",
        "Transports Martin",
        "362 521 879 00034",
        "FR 32 123456789",
        "123 rue de Belleville",
        "75019",
        "Paris",
    ],
    [
        "2",
        "Oreve Environment",
        "Transports Beauvau",
        "933 232 171 00034",
        "FR 32 987654321",
        "2 Place François Mireur",
        "13001",
        "Marseille",
    ],
]

const createEntityObject = (arr: string[]): EntitySchema => {
    return {
        id: arr[0],
        entity_name: arr[1],
        company_name: arr[2],
        siret: arr[3],
        tvaintra: arr[4],
        address: arr[5],
        zip_code: arr[6],
        city: arr[7],
    }
}

export const entitiesMockData: EntitySchema[] = entitiesArray.map((arr) =>
    createEntityObject(arr)
)
